module.exports = __webpack_public_path__ + "static/media/img4-1.9ed97bba.png";